import { createContext, useContext, useMemo, useState, useEffect } from "react";
import { useAuth } from "./AuthContext";
import { db, dbDev } from "../firebase-confg"
import { collection, doc, onSnapshot } from "firebase/firestore";

export const FirebaseConnectionContext = createContext();

const FirebaseConnectionProvider = (props) => {
  const { currentUser } = useAuth();

  const values = useMemo(
    () => ({
      currentUser,
    }),
    [currentUser]
  );

  return <FirebaseConnectionContext.Provider value={values} {...props} />;
};
export default FirebaseConnectionProvider;

export const useFirebaseConnectionContext = () => {
  const context = useContext(FirebaseConnectionContext);
  if (!context) {
    throw new Error(
      "useFirebaseConnectionContext doit être utilisé dans le context adéquat"
    );
  }

  return context;
};

export const useFirebaseWishesDataFetch = () => {
  const { currentUser } = useAuth();
  const [giftsList, setGiftsList] = useState(null);
  const wishesRef = collection(db, "wishes");

  //Il faut penser à modifier la bdd entre db et dbDev en fonction du statut en prod ou en dev
  useEffect(() => {
    const unsubscribe = onSnapshot(wishesRef, (snapshot) => {
      setGiftsList(
        snapshot.docs.map(
          (wish) => wish.data().userId === currentUser?.user?.uid && {
            id: wish.id,
            ...wish.data(),
          }
        )
          .filter(Boolean)
      );
    }, (error) => {
      return null
    });

    //remember to unsubscribe from your realtime listener on unmount or you will create a memory leak
    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { wishesRef, giftsList, setGiftsList };
};

export const useFirebaseFriendsDataFetch = () => {
  const { currentUser } = useAuth();
  const [friendsIdList, setFriendsIdList] = useState([]);
  const userRef = doc(db, "users", currentUser?.user?.uid);

  //Il faut penser à modifier la bdd entre db et dbDev en fonction du statut en prod ou en dev
  useEffect(() => {
    const unsubFriends = onSnapshot(userRef, (snapshot) => {
      setFriendsIdList(snapshot?.data()?.friends ?? []);
    }, (error) => {
      return null
    });

    //remember to unsubscribe from your realtime listener on unmount or you will create a memory leak
    return () => unsubFriends();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { friendsIdList, setFriendsIdList };
};
